// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuList_wrapper__2He9d","menu-item":"MenuList_menu-item__1cYg8","menu-text":"MenuList_menu-text__3p7aG","menu-icon":"MenuList_menu-icon__1BiB8"};